export function investment(to, from, next) {
    try{
        if (
            localStorage.getItem("userInfo") != null &&
            localStorage.getItem("userInfo").length > 0 &&
            JSON.parse(localStorage.getItem("userInfo")).currentUser.userType==0 ||  JSON.parse(localStorage.getItem("userInfo")).currentUser.userType==400||  JSON.parse(localStorage.getItem("userInfo")).currentUser.userType==300
        ) {
            next();
        } else {
            localStorage.removeItem("userInfo");
            next("/login");
        }
    }catch(err){
           console.log(err,"investment err")
    }
    
}
export function mechanism(to, from, next) {
    if (
        localStorage.getItem("userInfo") != null &&
        localStorage.getItem("userInfo").length > 0 &&
        JSON.parse(localStorage.getItem("userInfo")).currentUser.userType==100
    ) {
        next();
    } else {
        localStorage.removeItem("userInfo");
        next("/login");
    }
}
export function enterprise(to, from, next) {
    if (
        localStorage.getItem("userInfo") != null &&
        localStorage.getItem("userInfo").length > 0 &&
        JSON.parse(localStorage.getItem("userInfo")).currentUser.userType==200
    ) {
        next();
    } else {
        localStorage.removeItem("userInfo");
        next("/login");
    }
}